<template>
  <div>
    <div class="time-sheet-container">
      <table class="time-sheet-table">
        <thead>
          <tr>
            <th rowspan="2" class="date">Date</th>
            <th rowspan="2" class="day">Day</th>
            <th colspan="7" class="title-period">Period</th>
          </tr>
          <th class="period">1</th>
          <th class="period">2</th>
          <th class="period">3</th>
          <th class="period">4</th>
          <th class="period">5</th>
          <th class="period">6</th>
          <th class="period">7</th>
        </thead>
        <tbody>
          <tr
            v-for="{ day, dayOfWeek, style } of days"
            :key="day"
          >
            <td>{{ day }}</td>
            <td>
              <span :style="style">{{ dayOfWeek }}</span>
            </td>
            <td colspan="7" class="period-box">
              <div class="period-box-container">
                <div class="period-box-border"/>
                <div class="period-box-border"/>
                <div class="period-box-border"/>
                <div class="period-box-border"/>
                <div class="period-box-border"/>
                <div class="period-box-border"/>
                <div class="period-box-border"/>
              </div>
              <div v-if="schedulesOnDay(day).length > 0">
                <a
                  v-for="{ id, type, level, participantTime, style } of schedulesOnDay(day)"
                  :key="id"
                  :style="style"
                  :class="['mark', `${type}`]"
                  @click="clickedSchedule({ type, id })"
                >
                  {{ level && level.code || null }}
                  <div class="campusname-box" v-if="participantTime">
                    {{ participantTime }}m
                  </div>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Moment } from 'moment'
import { RootState } from '@/store/types'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Schedule, Timesheet } from '@/store/timesheets/types'
import { scheduleType } from '@/store/schedules/types'

@Component
export default class TimesheetDetailSchedule extends Vue {
  @Prop({ required: true }) date!: Moment

  @Prop() timesheet!: Timesheet

  private get tutorId(): string|null {
    return _.get(this.timesheet, 'tutor.id') || null
  }

  /**
   * 日にちごとの設定
   */
  private get days(): {
    day: number, // 日にち
    dayOfWeek: string, // 曜日
    style: Object, // 日にちのstyle(css)
  }[] {
    const lastDay = this.date.clone().endOf('month').get('date')
    return _.range(1, lastDay + 1).map((day) => {
      const date = this.date.clone().set('date', day)
      const dayOfWeek = date.format('ddd')
      let color = 'black'
      if (dayOfWeek === 'Sat') {
        color = 'green'
      } else if (dayOfWeek === 'Sun') {
        color = 'red'
      }

      return {
        day,
        dayOfWeek,
        style: { color },
      }
    })
  }

  private schedulesOnDay(day: number): Schedule[] {
    const schedules = _.get(this.timesheet, 'schedules') || []

    return _.filter(schedules, (schedule) => {
      // 対象日スケジュールのみ抽出
      return schedule.date.get('date') === day
    }).map((schedule) => {
      // styleを追加
      // startとendがない場合は終日の予定なので全部を指定する
      const start = schedule.start || 1
      const end = schedule.end || 7
      return {
        ...schedule,
        style: {
          width: `${(end - start) * 110 + 100}px`,
          left: `${(start - 1) * 110 + 5}px`,
        },
      }
    })
  }

  private clickedSchedule({ type, id }: { type: scheduleType, id: string }) {
    if (_.indexOf(['lesson', 'subLesson'], type) !== -1) {
      // レッスンの場合はレッスンスケジュールに遷移
      this.$router.push({ name: 'LessonDetails', params: { lessonId: id } })
    } else if (type === 'absent') {
      // 欠席の場合、何もしない
    } else {
      if ((this.$store.state as RootState).auth.profile?.authority === 'tutor') {
        // チューターの場合は何もしない（編集させないため）
        return
      }

      // 上記以外の場合はスケジュール編集画面に遷移
      this.$router.push({
        name: 'EditSchedule',
        params: {
          tutorId: this.tutorId as string,
          scheduleId: id,
        },
      })
    }
  }
}
</script>

<style scoped>

.time-sheet-container {
  margin-bottom: 30px;
  padding: 15px;
  background: #fff;
}

.time-sheet-table {
  width: 100%;
  background: #fff;
  border-collapse:collapse;
}

.time-sheet-table th {
  padding: 10px 0;
  vertical-align: top;
  text-align: center;
}

.time-sheet-table td {
  padding: 5px 0;
  border: 1px solid #B5B5B5;
  text-align: center;
}

.period {
  padding: 5px 0;
  width: 110px;
  text-align: center;
  background: #B3C6E7;
  border: 1px solid #B3C6E7;
}

.time-sheet-table td.period-box {
  position: relative;
  height: 50px;
  padding:0px;
}

.time-sheet-table td.no-data {
  padding: 20px;
  text-align: center;
  font-size: 17px;
  border: 1px solid #B5B5B5;
}

.time-sheet-table td.period-box .period-box-container {
  display: flex;
  height:100%;
}

.time-sheet-table td.period-box .period-box-border {
  display: block;
  width: 110px;
  border-right:1px solid #B5B5B5;
}

.time-sheet-table td.period-box .period-box-border:last-child {
  border-right: none;
}

.mark {
  height:60%;
  position: absolute;
  top:0px;
  bottom:0px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 30px;
  font-size:12px;
}

.mark.lesson {
  background: #DDEAF6;
  border:2px solid #DDEAF6;
  z-index: 10;
}

.mark.waiting {
  background: #87A4D9;
  border:2px solid #87A4D9;
  z-index: 20;
}

.mark.subLesson {
  background: #F7CAAC;
  border:2px solid #F7CAAC;
  z-index: 90;
}

.mark.workshopOrTutorTraining {
  background: #C39BE1;
  border:2px solid #C39BE1;
}

.mark.meeting {
  background: #F38181;
  border:2px solid #F38181;
}

.mark.workOnHolliday {
  background: #55A8FD;
  border:2px solid #55A8FD;
}

.mark.workOnHoliday {
  background: #0070C0;
  border:2px solid #0070C0;
}

.mark.absent {
  background: #A5A5A5;
  border:2px solid #A5A5A5;
}

.note {
  text-align: left;
  margin-left:10px;
}

.title-period {
  background: #ededed;
  border-bottom: 2px solid #fff;
}

.title-note {
  background: #ededed;
  border-left: 2px solid #fff;
}

.campusname-box {
  position: absolute;
  background: #ffffff;
  color:#000;
  right:2px;
  font-size: 10px;
  padding:3px;
  border:#2E75B5 2px solid;
  border-radius: 30px;
}
</style>
